// removed by extract-text-webpack-plugin
module.exports = {"metric":"_2kwZ","number":"_33wm","change":"_2Bx8","name":"_1YAo"};


//////////////////
// WEBPACK FOOTER
// ./src/features/CallAnalytics/Cards/KeyMetrics/KeyMetrics.scss
// module id = nXt9
// module chunks = 0